var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlatinumLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20.5287,
    cy: 20.2976,
    r: 20,
    fill: "#31E4A8"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9946 14.6908C22.686 14.6908 23.9202 15.0375 24.6972 15.7308C25.4741 16.4241 25.8626 17.3953 25.8626 18.6444C25.8626 19.2122 25.773 19.753 25.5937 20.267C25.4203 20.7751 25.1335 21.2263 24.733 21.6207C24.3326 22.0092 23.8037 22.317 23.1462 22.5441C22.4948 22.7713 21.6909 22.8848 20.7347 22.8848H19.3361V27.7976H17.1845V14.6908H20.9946ZM20.8512 16.4749H19.3361V21.0918H20.5105C21.1859 21.0918 21.7596 21.0141 22.2318 20.8587C22.704 20.6974 23.0626 20.4434 23.3076 20.0967C23.5526 19.7501 23.6752 19.2928 23.6752 18.7251C23.6752 17.966 23.4451 17.4012 22.9849 17.0307C22.5306 16.6601 21.8194 16.4749 20.8512 16.4749Z",
    fill: "#31E4A8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatinumLogo);
export default __webpack_public_path__ + "static/media/platinumLogo.717be7b6a018bf8a8fbedca96cdfd039.svg";
export { ForwardRef as ReactComponent };